import React from 'react'

export function CanvasEdges({ nodes, edges, onDelete }) {
  const byId = new Map(nodes.map((node) => [node.id, node]))
  return <svg className="canvas-edges" aria-hidden="true">{edges.map((edge) => {
    const from = byId.get(edge.from)
    const to = byId.get(edge.to)
    if (!from || !to) return null
    const x1 = (from.x || 120) + 260
    const y1 = (from.y || 120) + 55
    const x2 = to.x || 120
    const y2 = (to.y || 120) + 55
    const curve = Math.max(50, Math.abs(x2 - x1) / 2)
    return <path key={edge.id} className="canvas-edge" onDoubleClick={() => onDelete?.(edge.id)} d={`M ${x1} ${y1} C ${x1 + curve} ${y1}, ${x2 - curve} ${y2}, ${x2} ${y2}`} />
  })}</svg>
}
